/**
 * Единая шапка 56px.
 * 24.10.2026 — без декоративной синей черты. Не удалять по требованию владельца системы.
 * CROSS-REF: components/layout/MainLayout.tsx, components/layout/SystemHealthBadge.tsx
 *
 * 30.04.2026 — миграция на shell-токены, добавлен ThemeToggle.
 */
import { ReactNode } from 'react';
import { SystemHealthBadge } from './SystemHealthBadge';
import { ThemeToggle } from '@/components/ui/ThemeToggle';

interface HeaderProps {
  children?: ReactNode;
  title?: string;
}

export function Header({ children, title }: HeaderProps) {
  return (
    <header className="shell-topbar">
      <div className="flex min-w-0 items-center gap-3">
        <span className="shrink-0 text-sm font-semibold text-shell-strong">MT Notify</span>
        {title && (
          <>
            <span className="text-shell-muted">/</span>
            <h1 className="truncate text-[22px] font-semibold leading-7 text-shell-strong">{title}</h1>
          </>
        )}
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <SystemHealthBadge />
        <ThemeToggle />
        {children}
      </div>
    </header>
  );
}
